export default {
    _prefix: "qualityFormEditor.questionGroup",
    labels: {
        groupScoreScaleEditor:
            "Group Score Scaling Factor: {{#groupScoreScale}}{{/groupScoreScale}}",
        groupScoreScaleEditorScreenReader: "Change group score scaling factor",
        totalScaledPoints: "Total Scaled Points: {{#ScoreTag}}{{/ScoreTag}}",
    },
    errors: {
        emptyScalingFactor: "Scaling factor must not be empty",
        invalidScalingFactor: "Should be a number between 0 and 999,999.",
    },
};
